import React, { memo } from 'react';
import { Redirect, Switch } from 'react-router-dom';

import { AirportServicePage } from '../components/AirportServicePage/AirportServicePage';
import { FlightTaskPage } from '../components/FlightTaskPage/FlightTaskPage';
import { FlightPage } from '../components/FlightPage/FlightPage';
import { AttachmentsPage } from '../components/AttachmentsPage/AttachmentsPage';
import { FlightWizardPage } from '../components/FlightWizardPage/FlightWizardPage';
import { ReportsPage } from '../components/ReportsPage/ReportsPage';
import { EmployersPage } from '../components/EmployersPage/EmployersPage';
import { LibraryPage } from '../components/LibraryPage/LibraryPage';
import { MessengerPage } from '../components/MessengerPage/MessengerPage';
import { PassengerPage } from '../components/PassengerPage/PassengerPage';
import { SummaryTaskPage } from '../components/SummaryTaskPage/SummaryTaskPage';
import { useIsAuthenticated } from '../selectors/login';
import { PrivateRoute } from '../service/PrivateRoute';

export const MainContainer = memo(() => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <Switch>
            <PrivateRoute path="/flight-task" component={FlightTaskPage} auth={isAuthenticated} />
            <PrivateRoute path="/flight" component={FlightPage} auth={isAuthenticated} />
            <PrivateRoute path="/attachments" component={AttachmentsPage} auth={isAuthenticated} />
            <PrivateRoute path="/flight-info" component={FlightWizardPage} auth={isAuthenticated} />
            <PrivateRoute path="/reports" component={ReportsPage} auth={isAuthenticated} />
            <PrivateRoute path="/crew" component={EmployersPage} auth={isAuthenticated} />
            <PrivateRoute path="/library" component={LibraryPage} auth={isAuthenticated} />
            <PrivateRoute path="/messages" component={MessengerPage} auth={isAuthenticated} />
            <PrivateRoute path="/passengers" component={PassengerPage} auth={isAuthenticated} />
            <PrivateRoute path="/airport-service" component={AirportServicePage} auth={isAuthenticated} />
            <PrivateRoute path="/summary-task" component={SummaryTaskPage} auth={isAuthenticated} />
            {isAuthenticated ? <Redirect to="/flight-task" push /> : <Redirect to="/login" push />}
        </Switch>
    );
});

MainContainer.displayName = 'MainContainer';
